import DuoGridItemMobile from '@/components/atoms/images/duoGridItemMobile'
import Link from 'next/link'
import * as React from 'react'
import { ICar, ICarObj, IGalleryImage } from 'shared-interfaces'
import styled from 'styled-components'

const Wrapper = styled.section`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1px;
    width: 100%;
    height: 100%;
`

interface Props {
    carsIdsList: any[]
    carsdata: ICarObj
    garage_link_id: string
    get_cover_img: (car: ICar) => IGalleryImage | undefined
}

class DuoGridMobile extends React.Component<Props, {}> {
    componentDidMount() {}

    render() {
        return (
            <Wrapper>
                {this.props.carsIdsList.map((id, index) => {
                    let car = this.props.carsdata[id]

                    let cover: IGalleryImage | undefined =
                        this.props.get_cover_img(car)

                    return (
                        <Link
                            href={`/garage/${this.props.garage_link_id}/car/${id}/overview`}
                            key={index}
                        >
                            <a data-attr={`garage_grid_item_mobile_${id}`}>
                                <DuoGridItemMobile img={cover} />
                            </a>
                        </Link>
                    )
                })}
            </Wrapper>
        )
    }
}

export default DuoGridMobile
